import React from 'react';
import ReactGA from 'react-ga4';

const Content = () => {
  return (
    <>
      <div className="popup-content-title">
        <h3>Bentleigh – Jasper Road</h3>
      </div>
      <div className="popup-content-source">
        <p>
          <span className="bold">
          We’re renewing approximately 1.1 kilometres of water main along both sides of Jasper Road, from South Road to Brewer Road in Bentleigh. 
          The works also include renewing approximately 460m of water mains along South Road, between Jasper Road and Corbie Street, Bentleigh. 
          </span>
        </p>
        <p>
        We completed investigation works in early 2026 to help plan these works. 
        </p>
        <p>
        We’ve awarded this project to our Industry Partner Beca, Fulton Hogan, Interflow Joint Venture (BFHI) and expect to start works in January 2027.
        </p>
        <p>
          For more information visit{' '}
          <a
            href="https://southeastwater.com.au/faults-and-works/works/planned-works/jasper-and-south-roads/"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: `Map – Water Renewals (blue)`,
                action: '<a href> link',
                label: 'MORE INFO: Jasper and South Roads Water Main Renewal',
              });
            }}
          >
            Jasper and South Roads Water Main Renewal
            | South East Water
          </a>{' '}
          email{' '}
          <a
            href="mailto:engagement@sew.com.au"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: `Map - Water Renewals (blue)`,
                action: 'Email link',
                label:
                  'MAIL TO: engagement@sew.com.au: Jasper and South Roads Water Main Renewal',
              });
            }}
          >
            engagement@sew.com.au
          </a>{' '}
          or call <a href="tel:1800403777">1800 403 777</a> |{' '}
        </p>
      </div>
    </>
  );
};

export default Content;
